import { Box, Paper, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import SuperPowerItem from '@src/App/Components/Items/EntityItems/SuperPowerItem/SuperPowerItem';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';

function SuperPowersWidget() {
    // const theme = useTheme();
    const reduxEmployee = useSelector((state: AppState) => state.employee);
    const skills = reduxEmployee.skills || [];

    const superPowers = skills.filter((skill) => skill.isSuperPower === true);
    const order = reduxEmployee.superPowerOrder || [];

    // Apply custom order if exists
    if (order.length > 0) {
        const orderMap = new Map(order.map((id, index) => [id, index]));
        superPowers.sort((a, b) => {
            const orderA = orderMap.get(a.id) ?? Number.MAX_SAFE_INTEGER;
            const orderB = orderMap.get(b.id) ?? Number.MAX_SAFE_INTEGER;
            return orderA - orderB;
        });
    }

    if (superPowers.length === 0) {
        return (
            <Paper
                elevation={0}
                sx={{
                    p: { lg: 3, md: 2, xs: 2 },
                    border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                    borderRadius: 2,
                }}
            >
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                    SuperPowers
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
                    Noch keine SuperPowers definiert
                </Typography>
            </Paper>
        );
    }

    return (
        <Paper
            elevation={0}
            sx={{
                p: { lg: 3, md: 2, xs: 2 },
                border: (theme) => `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                borderRadius: 2,
            }}
        >
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                SuperPowers
            </Typography>

            <Box
                sx={{
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)' },
                    gap: 2,
                }}
            >
                {superPowers.map((skill, index) => (
                    <SuperPowerItem key={skill.id} skill={skill} isFocusPower={index === 0} />
                ))}
            </Box>
        </Paper>
    );
}

export default SuperPowersWidget;
